import React, { useState } from 'react';

const GRNConnectSupplierHighlight = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [billingCycle, setBillingCycle] = useState(1); // 1 = Monthly, 2 = Annually

  // Company Information - Zotrai (YOUR COMPANY)
  const companyInfo = {
    name: "Zotrai",
    themeColor: "#FF7F00",
    description: "Your trusted B2B travel technology partner",
    founded: "2020",
    headquarters: "India",
    agents: "10,000+",
    suppliers: "50+",
    countries: "100+",
    uptime: "99.9%",
    apiCalls: "100M+",
    team: "100+",
    email: "support@zotrai.com",
    phone: "+91-7207642485"
  };
// Why Suppliers Choose Zotrai - REAL DATA
  const whyZotraiData = {
    benefits: [
        {
        id: 1,
        title: "Single API Integration, Multiple Connections",
        description: "Connect once with Zotrai and get instant access to all our partner suppliers - no multiple integrations needed",
        icon: "ri-plug-line",
        stat: "1",
        statLabel: "Integration"
      },
     {
  id: 2,
  title: "Launch B2B, B2C & Corporate Portals",
  description: "Fully customizable multi-agent, direct-sell, and corporate booking platforms under your brand",
  icon: "ri-window-line",
  stat: "All-in-One",
  statLabel: "Portal Suite"
},
    
      {
  id: 3,
  title: "Save 95% on Integration Costs",
  description: "No setup fees, no integration charges.",
icon: "ri-coins-line",

  stat: "95%",
  statLabel: "Cost Savings"
},
      {
        id: 4,
        title: "Real-time Analytics Dashboard",
        description: "Track your inventory performance, booking patterns, and agent behavior with detailed analytics",
        icon: "ri-bar-chart-2-line",
        stat: "24/7",
        statLabel: "Monitoring"
      },
      {
        id: 5,
        title: "99.9% Uptime Guarantee",
        description: "Enterprise-grade infrastructure with redundant systems ensuring your APIs are always available",
        icon: "ri-shield-check-line",
        stat: "99.9%",
        statLabel: "Uptime"
      },
      {
        id: 6,
        title: "Dedicated Account Manager",
        description: "Every supplier gets a dedicated technical account manager for seamless integration and support",
        icon: "ri-customer-service-line",
        stat: "24/7",
        statLabel: "Support"
      }
    ],
    process: [
      {
        step: 1,
        title: "Add Your API Credentials",
        description: "Just Login, paste your API keys, and we handle the rest – zero development effort"
      },
       {
        step: 2,
        title: "Select & Customize Template",
        description: "Pick from our library of 100+ responsive templates and match your brand identity"
      },
      {
        step: 3,
        title: "Go Live Instantly",
        description: "Deploy to production in one click and start accepting real bookings"
      }
    ]
  };


  // SEO-friendly structured data for GRN Connect
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "GRN Connect",
    "description": "Eco-conscious travel supplier specializing in sustainable accommodations and green travel initiatives",
    "url": "https://www.grnconnect.com",
    "areaServed": "Worldwide",
    "serviceType": ["Eco-hotels", "Sustainable Tours", "Carbon Offset", "Green Travel"],
    "sustainability": {
      "@type": "Sustainability",
      "description": "Certified green accommodations and carbon-neutral travel options"
    }
  };

  // GRN Connect specific data
  const grnData = {
    name: "GRN Connect",
    description: "Eco-conscious travel supplier specializing in sustainable accommodations and green travel initiatives. Connecting agents with environmentally responsible properties worldwide.",
    longDescription: "GRN Connect is a pioneering travel technology company dedicated to promoting sustainable tourism through a curated network of eco-friendly accommodations and green travel experiences. Founded with a mission to make travel more environmentally responsible, GRN Connect partners with hotels, resorts, and lodges that meet strict sustainability criteria, including green certifications, carbon-neutral operations, and community engagement. Their platform enables travel agents to offer their clients authentic eco-conscious travel options without compromising on comfort or quality. From solar-powered eco-lodges in the rainforest to certified green hotels in urban centers, GRN Connect provides access to properties that are committed to protecting the planet while delivering exceptional guest experiences.",
    founded: "2015",
    headquarters: "Bangkok, Thailand",
    employees: "150+",
    countries: "75+",
    ecoHotels: "50,000+",
    ecoResorts: "10,000+",
    ecoLodges: "5,000+",
    sustainableTours: "2,500+",
    certifiedProperties: "15,000+",
    carbonOffset: "100,000+ tons",
    agents: "5,000+",
    themeColor: "#2E7D32", // Forest Green color
    website: "https://www.grnconnect.com",
    apiType: "RESTful API",
    integrationType: "Direct API Integration",
    support: "24/7 Green Travel Specialist Support",
    certifications: ["Green Key", "EarthCheck", "LEED", "Green Globe"]
  };

  // Key features of GRN Connect
  const features = [
    {
      icon: "🌿",
      title: "50,000+ Eco-Hotels",
      description: "Curated collection of environmentally certified hotels and green accommodations"
    },
    {
      icon: "🏝️",
      title: "10,000+ Eco-Resorts",
      description: "Sustainable resorts with solar power, water conservation, and local community engagement"
    },
    {
      icon: "🏕️",
      title: "5,000+ Eco-Lodges",
      description: "Immersive nature experiences in certified eco-lodges and jungle retreats"
    },
    {
      icon: "🌍",
      title: "Carbon Offset Programs",
      description: "Integrated carbon offset options for every booking to promote climate-positive travel"
    }
  ];

  // Services offered by GRN Connect
  const services = [
    {
      id: 1,
      title: "Eco-Hotel Booking API",
      description: "Access to 50,000+ certified eco-friendly hotels worldwide with real-time availability and instant confirmation.",
      features: [
        "Green certified properties",
        "Sustainability ratings",
        "Carbon footprint data",
        "Eco-initiatives details",
        "Real-time availability",
        "Instant confirmation"
      ],
      icon: "🌿"
    },
    {
      id: 2,
      title: "Eco-Resorts & Lodges",
      description: "Premium eco-resorts and lodges in pristine natural locations with sustainable operations.",
      features: [
        "Solar-powered resorts",
        "Rainforest eco-lodges",
        "Beachfront eco-resorts",
        "Wildlife sanctuaries",
        "Organic farm stays",
        "Nature immersion"
      ],
      icon: "🏝️"
    },
    {
      id: 3,
      title: "Sustainable Tours",
      description: "Curated eco-tours and experiences that support local communities and conservation efforts.",
      features: [
        "Wildlife conservation tours",
        "Community-based tourism",
        "Rainforest expeditions",
        "Marine conservation",
        "Cultural experiences",
        "Guided nature walks"
      ],
      icon: "🚶"
    },
    {
      id: 4,
      title: "Carbon Offset Integration",
      description: "Seamless carbon offset calculation and booking integration for climate-conscious travelers.",
      features: [
        "Real-time carbon calculation",
        "Verified offset projects",
        "Forest conservation",
        "Renewable energy projects",
        "Community initiatives",
        "Offset certificates"
      ],
      icon: "🌲"
    },
    {
      id: 5,
      title: "Green Certification Database",
      description: "Comprehensive database of properties with verified green certifications and sustainability credentials.",
      features: [
        "Green Key certified",
        "EarthCheck verified",
        "LEED certified",
        "Green Globe certified",
        "Rainforest Alliance",
        "Biodiversity audits"
      ],
      icon: "📋"
    },
    {
      id: 6,
      title: "Sustainable DMCs",
      description: "Destination management companies specializing in sustainable travel and eco-tourism.",
      features: [
        "Local DMC partners",
        "Sustainable itineraries",
        "Community engagement",
        "Conservation projects",
        "Ethical experiences",
        "Responsible tourism"
      ],
      icon: "🤝"
    }
  ];

  // Technology highlights
  const technology = [
    {
      title: "RESTful APIs",
      description: "Modern RESTful API architecture with comprehensive documentation"
    },
    {
      title: "Carbon Calculator",
      description: "Integrated carbon footprint calculation for every booking"
    },
    {
      title: "Real-time Availability",
      description: "Live inventory updates from eco-properties worldwide"
    },
    {
      title: "Green Certification Data",
      description: "Detailed sustainability metrics and certification information"
    },
    {
      title: "Multi-currency Support",
      description: "Transactions in multiple currencies with dynamic conversion"
    },
    {
      title: "Green Reporting",
      description: "Detailed reports on carbon offset and sustainability impact"
    }
  ];

  // Integration process
  const integrationProcess = [
    {
      step: 1,
      title: "API Documentation",
      description: "Receive comprehensive API docs and green data specifications"
    },
    {
      step: 2,
      title: "Sandbox Testing",
      description: "Test integration in GRN Connect's staging environment"
    },
    {
      step: 3,
      title: "Go Live",
      description: "Deploy to production with 24/7 green travel specialist support"
    }
  ];

  // Why choose GRN Connect
  const whyChoose = [
    "First movers in sustainable B2B travel distribution",
    "50,000+ certified eco-friendly properties",
    "Integrated carbon offset programs",
    "Verified green certifications (Green Key, EarthCheck, LEED)",
    "Support conservation and community development",
    "Appeal to the growing eco-conscious traveler segment"
  ];

  // Supplier logos array with navigation paths
  const suppliers = [
    { 
      id: 1, 
      name: "Tripjack", 
      logo: "/assets/images/suppliers/tripjack.png",
      path: "/supplier/trip-jack"
    },
    { 
      id: 2, 
      name: "TBO", 
      logo: "/assets/images/suppliers/tbo.png",
      path: "/supplier/tbo"
    },
    { 
      id: 3, 
      name: "Akbar Travels", 
      logo: "/assets/images/suppliers/akbar.png",
      path: "/supplier/akbar-travels"
    },
    { 
      id: 4, 
      name: "RezLive", 
      logo: "/assets/images/suppliers/rezlive.png",
      path: "/supplier/rezlive"
    },
    { 
      id: 5, 
      name: "GRN Connect", 
      logo: "/assets/images/suppliers/grn.png",
      path: "/supplier/grn-connect"
    },
    { 
      id: 6, 
      name: "Riya Travel", 
      logo: "/assets/images/suppliers/riya.png",
      path: "/supplier/riya-travel"
    },
    { 
      id: 7, 
      name: "Viator", 
      logo: "/assets/images/suppliers/viator.png",
      path: "/supplier/viator"
    },
    { 
      id: 8, 
      name: "Air iQ", 
      logo: "/assets/images/suppliers/airiq.png",
      path: "/supplier/air-iq"
    }
  ];

  // Pricing plans data
  const plans = [
    {
      id: 1,
      name: "Starter",
      description: "🚀 All-in-one powerful plan with complete access to every feature.",
      monthly: 2999,
      annually: 29999,
      popular: true,
      emoji: "🚀",
      features: [
        "Search, compare, and book flights from top global suppliers in one place",
        "Access and connect with 1,000+ verified global DMCs",
        "Smart accounting suite with ledgers, invoices, supplier settlements, and corporate payments",
        "Capture leads directly from social media and run promotions from a single dashboard",
        "Generate professional itineraries in minutes using AI",
        "AI-powered visa processing and document management system",
        "One unified platform for Flights, Hotels, Visas, Cars, Sightseeing, and more",
        "Integrated and secure payment gateway",
        "Plug in and manage your own supplier APIs seamlessly",
        "AI-based WhatsApp automation for leads, follow-ups, and customer support",
        "Unlimited email marketing and promotional campaigns",
        "Advanced reports and analytics for sales, revenue, and performance tracking",
      ],
      addons: [
        "Launch your own B2C booking website for customers in minutes – just INR 999",
        "Launch a full-featured B2C travel portal with flights, hotels, and packages using your preferred suppliers – INR 1,999",
        "Launch a B2B travel portal for your agent network with flights, hotels, and packages – INR 1,999",
        "Launch a B2E corporate travel portal for your business clients with flights, hotels, and packages – INR 1,999",
      ],
    },
  ];

  const getAccentColor = (planName) => {
    if (planName === "Starter") return "#10B981";
    if (planName === "Pro") return "#3B82F6";
    return "#8B5CF6";
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${companyInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${companyInfo.phone.replace(/[^0-9+]/g, '')}`;
  };

  const handleSupplierClick = (path) => {
    window.location.href = path;
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>GRN Connect - Sustainable Travel & Eco-Hotel Distribution | Zotrai</title>
        <meta name="description" content="GRN Connect is a pioneering sustainable travel platform offering 50,000+ eco-hotels, eco-resorts, and carbon offset programs through Zotrai integration." />
        <meta name="keywords" content="GRN Connect, sustainable travel, eco-hotels, green hotels, carbon offset, eco-tourism, sustainable tourism" />
        <link rel="canonical" href="https://yourcompany.com/supplier/grn-connect" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="GRN Connect - Sustainable Travel & Eco-Hotel Distribution" />
        <meta property="og:description" content="Connect with GRN Connect's network of 50,000+ certified eco-friendly properties through Zotrai's single API integration." />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Main Content with grn- prefix */}
      <div className="grn-supplier-container">
        {/* Header Section - GRN Connect Hero */}
        <header className="grn-header">
          <div className="grn-container">
            <h1 className="grn-title">
              <span className="grn-highlight" style={{ color: grnData.themeColor }}>GRN Connect</span>
              <br />
              Sustainable Travel & Eco-Hotel Distribution
            </h1>
            <p className="grn-subtitle">
              {grnData.description}
            </p>
          </div>
        </header>

        {/* Tabs Navigation - Same as others */}
        <div className="grn-tabs-container">
          <div className="grn-container">
            <div className="grn-tabs">
              <button 
                className={`grn-tab ${activeTab === 'about' ? 'grn-tab-active' : ''}`}
                onClick={() => setActiveTab('about')}
              >
                About
              </button>
              <button 
                className={`grn-tab ${activeTab === 'services' ? 'grn-tab-active' : ''}`}
                onClick={() => setActiveTab('services')}
              >
                Services
              </button>
              <button 
                className={`grn-tab ${activeTab === 'technology' ? 'grn-tab-active' : ''}`}
                onClick={() => setActiveTab('technology')}
              >
                Technology
              </button>
              <button 
                className={`grn-tab ${activeTab === 'whyzotrai' ? 'grn-tab-active' : ''}`}
                onClick={() => setActiveTab('whyzotrai')}
              >
                Why Zotrai <span className="grn-tab-badge">For Suppliers</span>
              </button>
              <button 
                className={`grn-tab ${activeTab === 'suppliers' ? 'grn-tab-active' : ''}`}
                onClick={() => setActiveTab('suppliers')}
              >
                Suppliers
              </button>
              <button 
                className={`grn-tab ${activeTab === 'pricing' ? 'grn-tab-active' : ''}`}
                onClick={() => setActiveTab('pricing')}
              >
                Pricing
              </button>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="grn-tab-content">
          {activeTab === 'about' && (
            <section className="grn-about">
              <div className="grn-container">
                <div className="grn-grid">
                  <div className="grn-about-content">
                    <h2 className="grn-section-title">About <span className="grn-accent" style={{ color: grnData.themeColor }}>GRN Connect</span></h2>
                    <p className="grn-text">
                      {grnData.longDescription}
                    </p>
                    
                    <div className="grn-features">
                      {features.map((feature, index) => (
                        <div key={index} className="grn-feature">
                          <span className="grn-feature-icon">{feature.icon}</span>
                          <div>
                            <h4>{feature.title}</h4>
                            <p>{feature.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="grn-card">
                    <h3 className="grn-card-title">GRN Connect at a Glance</h3>
                    <ul className="grn-list">
                      <li className="grn-list-item">
                        <span className="grn-check" style={{ color: grnData.themeColor }}>✓</span>
                        Founded 2015 • Pioneers in Sustainable Travel
                      </li>
                      <li className="grn-list-item">
                        <span className="grn-check" style={{ color: grnData.themeColor }}>✓</span>
                        50,000+ Eco-Hotels
                      </li>
                      <li className="grn-list-item">
                        <span className="grn-check" style={{ color: grnData.themeColor }}>✓</span>
                        10,000+ Eco-Resorts
                      </li>
                      <li className="grn-list-item">
                        <span className="grn-check" style={{ color: grnData.themeColor }}>✓</span>
                        5,000+ Eco-Lodges
                      </li>
                      <li className="grn-list-item">
                        <span className="grn-check" style={{ color: grnData.themeColor }}>✓</span>
                        75+ Countries Covered
                      </li>
                      <li className="grn-list-item">
                        <span className="grn-check" style={{ color: grnData.themeColor }}>✓</span>
                        15,000+ Certified Green Properties
                      </li>
                      <li className="grn-list-item">
                        <span className="grn-check" style={{ color: grnData.themeColor }}>✓</span>
                        Carbon Offset: 100,000+ tons
                      </li>
                      <li className="grn-list-item">
                        <span className="grn-check" style={{ color: grnData.themeColor }}>✓</span>
                        Green Key, EarthCheck, LEED Certified
                      </li>
                    </ul>

                    <h3 className="grn-card-title grn-mt-4">Certifications</h3>
                    <div className="grn-certification-tags">
                      {grnData.certifications.map((cert, index) => (
                        <span key={index} className="grn-cert-tag">{cert}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'services' && (
            <section className="grn-services">
              <div className="grn-container">
                <h2 className="grn-section-title grn-text-center">
                  Sustainable Travel Solutions
                </h2>
                <p className="grn-section-subtitle">
                  Through our integration with GRN Connect, we deliver eco-conscious travel technology solutions
                </p>

                <div className="grn-services-grid">
                  {services.map((service) => (
                    <div key={service.id} className="grn-service-card">
                      <div className="grn-service-icon">{service.icon}</div>
                      <h3 className="grn-service-title">{service.title}</h3>
                      <p className="grn-service-description">{service.description}</p>
                      <ul className="grn-service-list">
                        {service.features.map((feature, index) => (
                          <li key={index} className="grn-service-list-item">
                            <span className="grn-dot" style={{ color: grnData.themeColor }}>•</span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeTab === 'technology' && (
            <section className="grn-technology">
              <div className="grn-container">
                <div className="grn-grid">
                  <div className="grn-integration-box">
                    <h3 className="grn-card-title">Seamless Integration</h3>
                    <p className="grn-text">
                      Our integration with GRN Connect's robust APIs ensures smooth data flow, real-time updates, and reliable performance for sustainable travel bookings.
                    </p>
                    <div className="grn-tags">
                      {technology.map((tech, index) => (
                        <span key={index} className="grn-tag">{tech.title}</span>
                      ))}
                    </div>
                  </div>

                  <div className="grn-benefits-box">
                    <h3 className="grn-card-title">Key Advantages</h3>
                    <ul className="grn-benefits-list">
                      <li className="grn-benefits-item">
                        <span className="grn-benefits-icon">⚡</span>
                        Lightning-fast API response times
                      </li>
                      <li className="grn-benefits-item">
                        <span className="grn-benefits-icon">🛡️</span>
                        Enterprise-grade security protocols
                      </li>
                      <li className="grn-benefits-item">
                        <span className="grn-benefits-icon">🎧</span>
                        Green travel specialist support
                      </li>
                      <li className="grn-benefits-item">
                        <span className="grn-benefits-icon">👥</span>
                        Experienced integration team
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'whyzotrai' && (
            <section className="grn-why-zotrai-section">
              <div className="grn-container">
                {/* Header */}
                <div className="grn-why-header">
                  <span className="grn-why-badge" style={{ background: `${companyInfo.themeColor}15`, color: companyInfo.themeColor }}>
                    <i className="ri-question-line"></i> WHY SUPPLIERS CHOOSE ZOTRAI
                  </span>
                  <h2 className="grn-section-title">
                    Your Growth Partner in <span className="grn-accent" style={{ color: companyInfo.themeColor }}>Travel Distribution</span>
                  </h2>
                  <p className="grn-section-subtitle">
                    Join 50+ leading travel suppliers who trust us to connect them with travel agents
                  </p>
                </div>

                {/* Benefits Grid */}
                <div className="grn-benefits-grid-full">
                  {whyZotraiData.benefits.map((benefit) => (
                    <div key={benefit.id} className="grn-benefit-card">
                      <div className="grn-benefit-icon-wrapper" style={{ background: `${companyInfo.themeColor}15` }}>
                        <i className={benefit.icon} style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="grn-benefit-content">
                        <h3>{benefit.title}</h3>
                        <p>{benefit.description}</p>
                        <div className="grn-benefit-stat">
                          <span className="grn-stat-highlight" style={{ color: companyInfo.themeColor }}>{benefit.stat}</span>
                          <span className="grn-stat-label">{benefit.statLabel}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Integration Process */}
                <div className="grn-integration-process">
                  <h3 className="grn-process-title">Simple 3-Step Integration</h3>
                  <div className="grn-process-steps">
                    {whyZotraiData.process.map((step) => (
                      <div key={step.step} className="grn-process-step">
                        <div className="grn-step-number" style={{ background: companyInfo.themeColor }}>{step.step}</div>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Section */}
                <div className="grn-contact-section">
                  <h3>Ready to Join Our Supplier Network?</h3>
                  <p>Connect with agents through a single integration</p>
                  
                  <div className="grn-contact-info">
                    <div className="grn-contact-item" onClick={handleEmailClick}>
                      <div className="grn-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-mail-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="grn-contact-details">
                        <span className="grn-contact-label">Email Support</span>
                        <span className="grn-contact-value">{companyInfo.email}</span>
                      </div>
                    </div>

                    <div className="grn-contact-item" onClick={handlePhoneClick}>
                      <div className="grn-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-phone-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="grn-contact-details">
                        <span className="grn-contact-label">Phone Support</span>
                        <span className="grn-contact-value">{companyInfo.phone}</span>
                      </div>
                    </div>
                  </div>

                  <p className="grn-contact-note">
                    Our support team is available 24/7 to assist you with any questions
                  </p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'suppliers' && (
            <section className="grn-suppliers-section">
              <div className="grn-container">
                {/* Section Header */}
                <div className="grn-suppliers-header">
                  <span className="grn-suppliers-badge">
                    <i className="ri-handshake-line"></i> OUR INTEGRATED SUPPLIERS
                  </span>
                  <h2 className="grn-section-title">
                    Connect With <span className="grn-accent">Leading Travel Suppliers</span>
                  </h2>
                  <p className="grn-section-subtitle">
                    Direct integrations with industry-leading travel suppliers worldwide
                  </p>
                </div>

                {/* Clickable Logo Grid */}
                <div className="grn-logo-grid">
                  {suppliers.map((supplier) => (
                    <div 
                      key={supplier.id} 
                      className="grn-logo-item grn-clickable"
                      onClick={() => handleSupplierClick(supplier.path)}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleSupplierClick(supplier.path);
                        }
                      }}
                    >
                      <div className="grn-logo-wrapper">
                        <img 
                          src={supplier.logo} 
                          alt={supplier.name}
                          className="grn-supplier-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://via.placeholder.com/80x40?text=${supplier.name.charAt(0)}`;
                          }}
                        />
                      </div>
                      <span className="grn-logo-name">{supplier.name}</span>
                      <span className="grn-view-details-hint">
                        View Details <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  ))}
                </div>

                {/* Simple Stats */}
                <div className="grn-supplier-stats-simple">
                 
                  <div className="grn-stat-simple">
                    <span className="grn-stat-number">1M+</span>
                    <span className="grn-stat-label">Hotel Properties</span>
                  </div>
                  <div className="grn-stat-simple">
                    <span className="grn-stat-number">80+</span>
                    <span className="grn-stat-label">Airlines</span>
                  </div>
                  <div className="grn-stat-simple">
                    <span className="grn-stat-number">300K+</span>
                    <span className="grn-stat-label">Activities</span>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'pricing' && (
            <section className="grn-pricing-section">
              <div className="grn-container">
                <div className="grn-pricing-header">
                  <h2 className="grn-section-title grn-text-center">
                    Plans & <span className="grn-accent">Pricing</span>
                  </h2>
                  <p className="grn-section-subtitle">
                    Pick the plan that's right for your business growth
                  </p>
                  
                  {/* Billing Toggle */}
                  <div className="grn-billing-toggle">
                    <button
                      className={`grn-toggle-btn ${billingCycle === 1 ? 'grn-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(1)}
                    >
                      Monthly
                    </button>
                    <button
                      className={`grn-toggle-btn ${billingCycle === 2 ? 'grn-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(2)}
                    >
                      Annually
                      <span className="grn-save-badge">Save 20%</span>
                    </button>
                  </div>
                </div>

                {/* Pricing Cards */}
                <div className="grn-pricing-grid">
                  {plans.map((plan) => {
                    const isMonthly = billingCycle === 1;
                    const accentColor = getAccentColor(plan.name);
                    
                    return (
                      <div key={plan.id} className="grn-pricing-card-enhanced">
                        {plan.popular && (
                          <div className="grn-popular-badge">
                            ⭐ MOST POPULAR
                          </div>
                        )}

                        <div className="grn-pricing-card-content">
                          {/* Pricing Side */}
                          <div className="grn-pricing-left" style={{ backgroundColor: plan.popular ? '#F4F9FF' : '#ffffff' }}>
                            <div className="grn-pricing-emoji">{plan.emoji}</div>
                            <h3 className="grn-pricing-name">{plan.name}</h3>
                            <p className="grn-pricing-description">{plan.description}</p>

                            <div className="grn-pricing-amount">
                              <span className="grn-currency">INR</span>
                              <span className="grn-price">
                                {isMonthly ? plan.monthly.toLocaleString() : plan.annually.toLocaleString()}
                              </span>
                              <span className="grn-pricing-period">
                                /{isMonthly ? 'month' : 'year'}
                              </span>
                            </div>

                            <button 
                              className="grn-pricing-cta"
                              style={{ backgroundColor: accentColor }}
                              onClick={() => window.location.href = '/signup'}
                            >
                              Start Free Trial <i className="ri-arrow-right-line"></i>
                            </button>

                            {/* Quick 3-Step Setup */}
                            <div className="grn-quick-setup">
                              <h4 className="grn-setup-title">Quick 3-Step Setup</h4>
                              <div className="grn-setup-steps">
                                <div className="grn-setup-step">
                                  <div className="grn-step-marker" style={{ background: accentColor }}>1</div>
                                  <div className="grn-step-content">
                                    <strong>Sign Up & Choose Plan</strong>
                                    <span>Create your account in 30 seconds - no credit card required</span>
                                  </div>
                                </div>
                                <div className="grn-setup-step">
                                  <div className="grn-step-marker" style={{ background: accentColor }}>2</div>
                                  <div className="grn-step-content">
                                    <strong>Select Your Suppliers</strong>
                                    <span>Choose from leading travel suppliers with one click</span>
                                  </div>
                                </div>
                                <div className="grn-setup-step">
                                  <div className="grn-step-marker" style={{ background: accentColor }}>3</div>
                                  <div className="grn-step-content">
                                    <strong>Launch Your Portal</strong>
                                    <span>Go live with your branded website in minutes</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Features Side */}
                          <div className="grn-pricing-right">
                            <h5 className="grn-features-title" style={{ color: accentColor }}>
                              Included in {plan.name}
                            </h5>
                            
                            <div className="grn-features-list">
                              {plan.features.map((feature, index) => (
                                <div key={index} className="grn-feature-item">
                                  <div className="grn-feature-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-check-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{feature}</span>
                                </div>
                              ))}
                            </div>

                            <h5 className="grn-features-title grn-addons-title" style={{ color: accentColor }}>
                              Add-Ons
                            </h5>
                            
                            <div className="grn-addons-list">
                              {plan.addons.map((addon, index) => (
                                <div key={index} className="grn-addon-item">
                                  <div className="grn-addon-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-add-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{addon}</span>
                                </div>
                              ))}
                            </div>

                            <div className="grn-pricing-footer">
                              <span>✓ Transparent pricing, no hidden fees</span>
                              <span className="grn-support-link" style={{ color: accentColor }}>
                                Need help? Chat with us
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          )}
        </div>
      </div>

      {/* Styles with grn- prefix */}
      <style jsx>{`
        .grn-supplier-container {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
          line-height: 1.6;
          color: #1e293b;
        }

        .grn-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Header Styles */
        .grn-header {
          background: #ffffff;
          color: #1e293b;
          padding: 80px 0 40px;
          text-align: center;
        }

        .grn-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin: 0 0 15px;
          line-height: 1.2;
          color: #1e293b;
        }

        .grn-highlight {
          font-size: 4rem;
          display: inline-block;
          font-weight: 800;
        }

        .grn-subtitle {
          font-size: 1.25rem;
          max-width: 700px;
          margin: 0 auto;
          color: #475569;
        }

        /* Tabs Navigation */
        .grn-tabs-container {
          background: #ffffff;
          border-bottom: 2px solid #e2e8f0;
          margin-bottom: 40px;
          position: sticky;
          top: 0;
          z-index: 100;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }

        .grn-tabs {
          display: flex;
          gap: 30px;
          overflow-x: auto;
          padding: 0 24px;
        }

        .grn-tab {
          background: none;
          border: none;
          padding: 16px 0;
          font-size: 1rem;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          position: relative;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }

        .grn-tab:hover {
          color: #0f172a;
        }

        .grn-tab-active {
          color: #0f172a;
        }

        .grn-tab-active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 3px;
          background: ${grnData.themeColor};
        }

        .grn-tab-badge {
          background: ${grnData.themeColor};
          color: white;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 500;
        }

        /* About Section */
        .grn-about {
          padding: 40px 0 60px;
          background: #ffffff;
        }

        .grn-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 50px;
          align-items: start;
        }

        .grn-section-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .grn-text-center {
          text-align: center;
        }

        .grn-accent {
          position: relative;
          display: inline-block;
        }

        .grn-accent::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 4px;
          background: ${grnData.themeColor};
          border-radius: 2px;
        }

        .grn-text {
          font-size: 1.1rem;
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.8;
        }

        .grn-features {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin-top: 30px;
        }

        .grn-feature {
          display: flex;
          gap: 15px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .grn-feature:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          border-color: ${grnData.themeColor};
        }

        .grn-feature-icon {
          font-size: 2rem;
          min-width: 50px;
        }

        .grn-feature h4 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 5px;
          color: #0f172a;
        }

        .grn-feature p {
          font-size: 0.95rem;
          color: #475569;
          margin: 0;
        }

        .grn-card {
          background: white;
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
        }

        .grn-card-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .grn-mt-4 {
          margin-top: 30px;
        }

        .grn-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .grn-list-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          font-size: 1rem;
          color: #334155;
        }

        .grn-check {
          font-weight: bold;
          font-size: 1.2rem;
        }

        .grn-certification-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .grn-cert-tag {
          background: #f1f5f9;
          color: #334155;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 500;
          border: 1px solid #e2e8f0;
        }

        /* Services Section */
        .grn-services {
          padding: 40px 0 60px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .grn-section-subtitle {
          font-size: 1.25rem;
          color: #475569;
          text-align: center;
          max-width: 700px;
          margin: 0 auto 50px;
        }

        .grn-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .grn-service-card {
          background: white;
          padding: 35px 25px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
        }

        .grn-service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: ${grnData.themeColor};
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .grn-service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(46, 125, 50, 0.1);
        }

        .grn-service-card:hover::before {
          transform: scaleX(1);
        }

        .grn-service-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }

        .grn-service-title {
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .grn-service-description {
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .grn-service-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .grn-service-list-item {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          color: #475569;
          font-size: 0.95rem;
        }

        .grn-dot {
          font-weight: bold;
        }

        /* Technology Section */
        .grn-technology {
          padding: 40px 0 60px;
          background: white;
        }

        .grn-integration-box,
        .grn-benefits-box {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          padding: 40px;
          border-radius: 24px;
          border: 1px solid #eef2f6;
        }

        .grn-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 25px;
        }

        .grn-tag {
          background: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-size: 0.9rem;
          color: ${grnData.themeColor};
          font-weight: 500;
          border: 1px solid ${grnData.themeColor}30;
          transition: all 0.3s ease;
        }

        .grn-tag:hover {
          background: ${grnData.themeColor};
          color: white;
          border-color: ${grnData.themeColor};
          transform: scale(1.05);
        }

        .grn-benefits-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .grn-benefits-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          font-size: 1.1rem;
          color: #1e293b;
        }

        .grn-benefits-icon {
          font-size: 1.5rem;
          background: white;
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        /* Why Zotrai Section */
        .grn-why-zotrai-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .grn-why-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .grn-why-badge {
          display: inline-block;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
        }

        .grn-benefits-grid-full {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
          margin-bottom: 50px;
        }

        .grn-benefit-card {
          display: flex;
          gap: 20px;
          background: #f8fafc;
          padding: 25px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
        }

        .grn-benefit-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.05);
          border-color: ${companyInfo.themeColor};
        }

        .grn-benefit-icon-wrapper {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .grn-benefit-icon-wrapper i {
          font-size: 2rem;
        }

        .grn-benefit-content h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 8px;
          color: #0f172a;
        }

        .grn-benefit-content p {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 12px;
          line-height: 1.6;
        }

        .grn-benefit-stat {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .grn-stat-highlight {
          font-size: 1.2rem;
          font-weight: 700;
        }

        .grn-integration-process {
          text-align: center;
          margin: 60px 0;
        }

        .grn-process-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 40px;
          color: #0f172a;
        }

        .grn-process-steps {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .grn-process-step {
          text-align: center;
          padding: 30px;
          background: #f8fafc;
          border-radius: 20px;
          border: 1px solid #eef2f6;
        }

        .grn-process-step .grn-step-number {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 auto 20px;
        }

        /* Contact Section */
        .grn-contact-section {
          background: #ffffff;
          padding: 60px;
          border-radius: 30px;
          text-align: center;
          color: #0f172a;
          margin-top: 60px;
          border: 2px solid #eef2f6;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        .grn-contact-section h3 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .grn-contact-section p {
          font-size: 1.2rem;
          color: #475569;
          margin-bottom: 40px;
        }

        .grn-contact-info {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .grn-contact-item {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 20px 30px;
          background: #f8fafc;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 280px;
        }

        .grn-contact-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-color: ${companyInfo.themeColor};
        }

        .grn-contact-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .grn-contact-icon i {
          font-size: 1.8rem;
        }

        .grn-contact-details {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .grn-contact-label {
          font-size: 0.85rem;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .grn-contact-value {
          font-size: 1.2rem;
          font-weight: 600;
          color: #0f172a;
        }

        .grn-contact-note {
          font-size: 0.95rem !important;
          color: #64748b !important;
          margin-top: 20px;
          margin-bottom: 0 !important;
        }

        /* Suppliers Section */
        .grn-suppliers-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .grn-suppliers-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .grn-suppliers-badge {
          display: inline-block;
          background: linear-gradient(135deg, #2563eb15, #7c3aed15);
          color: #2563eb;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
          border: 1px solid #2563eb20;
        }

        .grn-suppliers-badge i {
          margin-right: 8px;
        }

        .grn-logo-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-bottom: 50px;
        }

        .grn-logo-item {
          text-align: center;
          padding: 20px;
          background: white;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .grn-logo-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(37, 99, 235, 0.15);
          border-color: #2563eb;
        }

        .grn-logo-item:hover .grn-view-details-hint {
          opacity: 1;
          transform: translateY(0);
        }

        .grn-logo-wrapper {
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 15px;
        }

        .grn-supplier-logo {
          max-width: 120px;
          max-height: 60px;
          object-fit: contain;
          transition: transform 0.3s ease;
        }

        .grn-logo-item:hover .grn-supplier-logo {
          transform: scale(1.05);
        }

        .grn-logo-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1e293b;
          display: block;
          margin-bottom: 5px;
        }

        .grn-view-details-hint {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
          color: #2563eb;
          font-weight: 500;
          opacity: 0;
          transform: translateY(10px);
          transition: all 0.3s ease;
        }

        .grn-supplier-stats-simple {
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: linear-gradient(135deg, #f8fafc, #ffffff);
          padding: 30px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          flex-wrap: wrap;
          gap: 20px;
        }

        .grn-stat-simple {
          text-align: center;
        }

        .grn-stat-simple .grn-stat-number {
          display: block;
          font-size: 2rem;
          font-weight: 800;
          color: #2563eb;
          line-height: 1.2;
        }

        .grn-stat-simple .grn-stat-label {
          font-size: 0.9rem;
          color: #64748b;
        }

        /* Pricing Section */
        .grn-pricing-section {
          padding: 40px 0 80px;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        }

        .grn-pricing-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .grn-billing-toggle {
          display: inline-flex;
          background: white;
          padding: 4px;
          border-radius: 50px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-top: 20px;
        }

        .grn-toggle-btn {
          border: none;
          padding: 12px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: transparent;
          color: #64748b;
          position: relative;
        }

        .grn-toggle-active {
          background: #2563eb;
          color: white;
        }

        .grn-save-badge {
          background: #fbbf24;
          color: #1e293b;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          margin-left: 8px;
          font-weight: 500;
        }

        .grn-pricing-grid {
          max-width: 1000px;
          margin: 0 auto;
        }

        .grn-pricing-card-enhanced {
          background: white;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .grn-pricing-card-enhanced:hover {
          transform: translateY(-5px);
          box-shadow: 0 30px 60px rgba(37, 99, 235, 0.12);
        }

        .grn-popular-badge {
          position: absolute;
          top: 20px;
          right: 30px;
          background: #2563eb;
          color: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.85rem;
          z-index: 10;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .grn-pricing-card-content {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
        }

        .grn-pricing-left {
          padding: 40px;
          border-right: 1px solid #eef2f6;
        }

        .grn-pricing-emoji {
          font-size: 2.5rem;
          margin-bottom: 15px;
        }

        .grn-pricing-name {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 10px;
          color: #0f172a;
        }

        .grn-pricing-description {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 25px;
        }

        .grn-pricing-amount {
          margin-bottom: 25px;
        }

        .grn-currency {
          font-size: 1.2rem;
          font-weight: 600;
          color: #64748b;
          margin-right: 5px;
        }

        .grn-price {
          font-size: 3.5rem;
          font-weight: 800;
          color: #0f172a;
          line-height: 1;
        }

        .grn-pricing-period {
          font-size: 1rem;
          color: #64748b;
          margin-left: 5px;
        }

        .grn-pricing-cta {
          width: 100%;
          border: none;
          padding: 16px;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          font-size: 1.1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 30px;
        }

        .grn-pricing-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }

        .grn-quick-setup {
          background: #f8fafc;
          border-radius: 16px;
          padding: 20px;
        }

        .grn-setup-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          color: #0f172a;
        }

        .grn-setup-steps {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .grn-setup-step {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .grn-step-marker {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .grn-step-content {
          display: flex;
          flex-direction: column;
        }

        .grn-step-content strong {
          font-size: 0.95rem;
          margin-bottom: 4px;
        }

        .grn-step-content span {
          font-size: 0.85rem;
          color: #64748b;
        }

        .grn-pricing-right {
          padding: 40px;
          background: #ffffff;
        }

        .grn-features-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .grn-addons-title {
          margin-top: 30px;
        }

        .grn-features-list,
        .grn-addons-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .grn-feature-item,
        .grn-addon-item {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .grn-feature-check,
        .grn-addon-check {
          width: 22px;
          height: 22px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .grn-feature-check i,
        .grn-addon-check i {
          font-size: 14px;
        }

        .grn-feature-item span,
        .grn-addon-item span {
          font-size: 0.95rem;
          color: #334155;
          line-height: 1.5;
        }

        .grn-pricing-footer {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
        }

        .grn-support-link {
          cursor: pointer;
          font-weight: 500;
        }

        .grn-support-link:hover {
          text-decoration: underline;
        }

        /* Accessibility */
        .grn-clickable:focus-visible {
          outline: 3px solid #2563eb;
          outline-offset: 2px;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .grn-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          
          .grn-services-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .grn-benefits-grid-full {
            grid-template-columns: 1fr;
          }

          .grn-process-steps {
            grid-template-columns: 1fr;
          }

          .grn-logo-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .grn-pricing-card-content {
            grid-template-columns: 1fr;
          }

          .grn-pricing-left {
            border-right: none;
            border-bottom: 1px solid #eef2f6;
          }

          .grn-contact-info {
            flex-direction: column;
            align-items: center;
          }

          .grn-contact-item {
            width: 100%;
            max-width: 400px;
          }
        }

        @media (max-width: 768px) {
          .grn-title {
            font-size: 2.5rem;
          }
          
          .grn-highlight {
            font-size: 3rem;
          }
          
          .grn-tabs {
            gap: 20px;
            overflow-x: auto;
            padding-bottom: 5px;
          }
          
          .grn-tab {
            font-size: 0.95rem;
            white-space: nowrap;
          }
          
          .grn-services-grid {
            grid-template-columns: 1fr;
          }
          
          .grn-section-title {
            font-size: 2rem;
          }

          .grn-features {
            grid-template-columns: 1fr;
          }

          .grn-logo-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .grn-supplier-stats-simple {
            flex-direction: column;
            gap: 20px;
          }

          .grn-contact-section {
            padding: 40px 20px;
          }

          .grn-contact-section h3 {
            font-size: 1.8rem;
          }

          .grn-contact-item {
            padding: 15px 20px;
          }

          .grn-contact-value {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .grn-header {
            padding: 60px 0 30px;
          }

          .grn-logo-grid {
            grid-template-columns: 1fr;
          }

          .grn-pricing-left,
          .grn-pricing-right {
            padding: 25px;
          }

          .grn-price {
            font-size: 2.5rem;
          }

          .grn-billing-toggle {
            flex-direction: column;
            width: 100%;
            border-radius: 12px;
          }

          .grn-toggle-btn {
            width: 100%;
          }

          .grn-contact-item {
            flex-direction: column;
            text-align: center;
          }

          .grn-contact-details {
            align-items: center;
          }
        }
      `}</style>
    </>
  );
};

// Simple Helmet component for meta tags
const Helmet = ({ children }) => {
  return <>{children}</>;
};

export default GRNConnectSupplierHighlight;